import { useEffect, useState } from "react";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../assets/images/RAPS-Logo.png";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { retrieveConvergencePageMenu } from "../../redux/slice/convergence/convergence-pages-menu-slice";
import { retrieveMasterPageConfiguration } from "../../redux/slice/master-page-configuration-slice";
import { retrieveUserInfo } from "../../redux/slice/sso/userinfo.slice";
import { RootState, useAppDispatch } from "../../redux/store";

const Convergence2023Header = () => {
  const dispatch = useAppDispatch();
  const path = "%2FConvergence-2023%2FSite-Nav";
  const { masterPageConfigurationData } = useSelector((state: RootState) => state.masterPageConfiguration);
  const { ConvergencePagesMenuData } = useSelector((state: RootState) => state.ConvergencePageMenu);
  const { checkLogin } = useSelector((state: RootState) => state.loggedIn);
  const userInfoData = useSelector((state: RootState) => state.userInfo.data);

  useEffect(() => {
    dispatch(retrieveConvergencePageMenu(path));
    dispatch(retrieveMasterPageConfiguration());
  }, [dispatch]);

  /*useEffect(() => {
    dispatch(retrieveUserInfo());
  }, [dispatch]);*/

  /* Comment during off-season */
  /*useEffect(() => {
    setAdScroll()
  }, []);*/

  useDynamicScripts({ htmlScriptString: masterPageConfigurationData[0]?.masterPageData[0]?.globalScripts || "", divId: "globalScript" });

  return (
    <>
      {/*<RenderAds />*/}
      {/*<header className="convergence-header">*/}
      <Navbar bg="dark" className="bg-primary sticky-top navbar-dark" expand="lg">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            {ConvergencePagesMenuData[0]?.navBarItemsList?.map((item, index) => {
              return item.childNavigation?.length === 0 ? (
                <Nav.Link href={item.url} key={index} target={item.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: item.text }}></Nav.Link>
              ) : (
                <NavDropdown id={"nav-dropdown-dark-example-" + index} title={item.text} menuVariant="dark" key={index} renderMenuOnMount={true}>
                  {item.childNavigation?.map((itm, indx) => {
                    return <NavDropdown.Item href={itm.url} key={indx} target={itm.isTargetBlank ? "_blank" : ""} dangerouslySetInnerHTML={{ __html: itm.text }}></NavDropdown.Item>;
                  })}
                </NavDropdown>
              );
            })}
          </Nav>
        </Navbar.Collapse>
        <div className="form-inline">
          {/*{checkLogin.isLoggedIn ? (
            userInfoData.result ? (
              <span className="navbar-brand greeting">Hi, {userInfoData.result?.firstName}</span>
            ) : (
              <></>
            )
          ) : (
            <Link to="/login?returnurl=/convergence-2023/home" className="btn btn-secondary text-light mr-4" role="button">
              Sign In
            </Link>
          )}*/}
          <Link className="navbar-brand" style={{ marginRight: 0 }} to="/">
            <img alt="RAPS.org" src={logo} />
          </Link>
        </div>
      </Navbar>
      {/*</header>*/}
    </>
  );
};

export default Convergence2023Header;

const RenderAds = () => {
  return (
    <>
      <div className="adsdiv" style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "5px auto" }}>
        {/* /22240682100/Convergence_970x90 */}
        <div className="CMSBanner Banner topbanner gadsbanner" id="div-gpt-ad-1692883213405-0" style={{ width: "970px", height: "90px" }}></div>
        {/* /22240682100/Convergence_300x50_TopBanner */}
        <div className="CMSBanner Banner mobilebanner gadsbanner" id="div-gpt-ad-1692883068939-0" style={{ width: "300px", height: "50px" }}></div>
      </div>
      <style>{`
        @media only screen and (min-width: 1025px) {
          .topbanner { display: block; }
          .mobilebanner { display: none; }
        }
        @media only screen and (max-width: 1025px) {
         .topbanner { display: none; }
         .mobilebanner { display: block; }
        }
         /* Comment during off-season */
        .fixed-top { top: 5px; position: relative; }
        #header-image { margin-top: 5px }
        body { padding-top: 5px !important; }
        .nav-item.dropdown:hover .dropdown-menu {
          display: block;
        }
      `}</style>
    </>
  );
};

function setAdScroll() {

  $(function () {
    window.onscroll = function () { navbarPosition() };
    var sticky = $('.navbar').offset()?.top;

    function navbarPosition() {
      var adsdiv = 0;// ($('.topbanner').css('display') == 'none') ? 0 : 90;
      if (window.pageYOffset >= (sticky ?? 0)) {
        $('.navbar').css('position', 'fixed');
        $('.navbar').css('top', 0 + adsdiv);
      } else {
        $('.navbar').css('position', 'relative');
        $('.navbar').css('top', 5 + adsdiv);
      }
    }
    navbarPosition();
  });
}